import React from 'react';

import { Engine } from './audio-player-engine';
import { ActiveBar, ActivePoint, ActiveProgress, CloseSVG, PlayerWrapper, Progress, ProgressBar, Time } from './audio-player.styled';

export class AudioPlayer extends React.Component {
  state = {
    duration: '00 : 00 : 00',
    progress: 0,
  };

  progressBar = null;

  componentDidMount() {
    this.engine = new Engine(this.props.file, this.setDuration, this.setProgress, this.progressBar);
  }

  componentWillUnmount = () => {
    this.engine.stop();
  };

  setProgress = (progress, cb) => {
    this.setState({ progress: progress });
    cb && cb();
  };

  setDuration = (duration) => {
    let durationHours = Math.round(duration / 3600) < 10 ? '0' + Math.round(duration / 3600) : Math.round(duration / 3600);
    let durationMinutes = Math.round(duration / 60) < 10 ? '0' + Math.round(duration / 60) : Math.round(duration / 60);
    let durationSeconds = Math.round(duration % 60) < 10 ? '0' + Math.round(duration % 60) : Math.round(duration % 60);
    this.setState({
      duration: `${durationHours} : ${durationMinutes} : ${durationSeconds}`,
    });
  };

  render() {
    return (
      <PlayerWrapper className="player">
        <Progress>
          <ActiveProgress>
            <ActiveBar width={this.state.progress + '%'} />
            <ActivePoint />
          </ActiveProgress>
          <ProgressBar
            onClick={(e) => {
              this.engine.pickNewProgress(e);
            }}
            innerRef={(ref) => {
              this.progressBar = ref;
            }}
          />
        </Progress>
        <Time>{this.state.duration}</Time>
        <CloseSVG>
          <svg onClick={this.props.close} xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
          </svg>
        </CloseSVG>
        {/* <Close onClick={this.props.close} src="/images/close-black.png" /> */}
      </PlayerWrapper>
    );
  }
}
